import styles from './Slide4.module.css';
import SlideShell from './SlideShell';

export default function Slide4({ handleNext, handlePrev, current, total, t }) {
  return (
    <SlideShell handleNext={handleNext} handlePrev={handlePrev} current={current} total={total} t={t}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <p className={styles.title}>{t("intro_play_learn_create_daily_title")}</p>
          <p className={styles.text}>{t("intro_games_puzzles_coloring_description")}</p>
        </div>
        <div className={styles.gameCards}>
          <div className={styles.gameCardLarge}>
            <div className={styles.cardHeader}>
              <div className={`${styles.iconWrapper} ${styles.iconWrapperPuzzle}`}>
                <img src='/assets/intro/puzzle.svg' alt='' height={22} width={22}/>
              </div>
              <span className={styles.cardTitle}>{t("puzzles")}</span>
            </div>
            <img src='/assets/intro/puzzleImage.png' alt='' className={styles.cardImage}/>
            <div className={styles.tags}>
              <div className={`${styles.tag} ${styles.tagPuzzle}`}>
                <span className={styles.tagText}>{t("logic")}</span>
              </div>
              <div className={`${styles.tag} ${styles.tagPuzzle}`}>
                <span className={styles.tagText}>{t("patience")}</span>
              </div>
            </div>
          </div>
          <div className={styles.gameCardSmall}>
            <div className={styles.cardHeader}>
              <div className={`${styles.iconWrapper} ${styles.iconWrapperPainting}`}>
                <img src='/assets/intro/painting.svg' alt='' height={22} width={22}/>
              </div>
              <span className={styles.cardTitle}>{t("painting")}</span>
            </div>
            <img src='/assets/intro/paintingImage.png' alt='' className={styles.cardImage}/>
            <div className={styles.tags}>
              <div className={`${styles.tag} ${styles.tagPainting}`}>
                <span className={styles.tagTextBlue}>{t("creativity")}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.infoBlock}>
          <img src='/assets/intro/stars.svg' alt='' height={45} width={45} />
          <div className={styles.infoContent}>
            <span className={styles.infoTitle}>{t("did_you_know")}</span>
            <span className={styles.infoText}>{t("intro_puzzles_neural_development_fact")}</span>
          </div>
        </div>
      </div>
    </SlideShell>
  );
}